import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  primary: {
    backgroundColor: theme.colors.notice_background
  },
  containerSmall: {
    width: '100%',
    padding: theme.spacing(2, 0),
    fontSize: 14
  },
  notificationContentContainerSmall: {
    display: 'flex',
    alignItems: 'center'
  },
  iconSmall: {
    margin: '8px 8px 8px 32px',
    height: 16
  },
  grid: {
    color: theme.palette.common.white
  }
}));

export default useStyles;
